<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%"
          src="../../../static/img/solutions/actualmeasurement/banner.png"
          alt="#"
        />
      </Col>
      <Col span="24" class="ContactUs_1">
        <div class="box_1">
          <div
            class="box1"
            @click="switching(1)"
            :class="{ active: isSHOW == 1 }"
          >
            <div class="box_font">
              <div>传统测量痛点</div>
              <div>
                <img
                  v-if="isSHOW == 1"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="box2"
            @click="switching(2)"
            :class="{ active: isSHOW == 2 }"
          >
            <div class="box_font">
              <div>行业现状</div>
              <div>
                <img
                  v-if="isSHOW == 2"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="box3"
            @click="switching(3)"
            :class="{ active: isSHOW == 3 }"
          >
            <div class="box_font">
              <div>解决方案</div>
              <div>
                <img
                  v-if="isSHOW == 3"
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="box_2">
          <div class="box_3">
            <div>
              <div style="font-size: 20px">耗费时力和人力</div>
              <div>
                传统测量方式往往需要测绘人员亲自到现场，使用经纬仪、测距仪等工具进行数据采集。这一过程不仅耗时较长，还需要大量的人力资源。
              </div>
            </div>
            <div style="margin-top: 10px">
              <div style="font-size: 20px">易产生误差</div>
              <div>
                由于传统测量主要依赖人工操作，因此在数据采集、分析和处理等各个环节都容易产生误差。这些误差可能来源于人为的疏忽、工具的精度限制或环境因素等，最终导致测量结果出现偏差。
              </div>
            </div>
            <div style="margin-top: 10px">
              <div style="font-size: 20px">缺乏智能化和自动化</div>
              <div>
                随着科技的进步，智能化和自动化已经成为各行各业的发展趋势。然而，传统测量方式在这方面相对滞后，仍然主要依赖人工操作。这不仅限制了测量效率的提升，还增加了人为误差的风险。
                难以应对复杂环境
                在一些复杂的环境中，如山区、水域或危险区域，传统测量方式往往难以实施。这些环境对测绘人员的安全构成威胁，同时也增加了测量的难度和不确定性。
              </div>
            </div>
            <div style="margin-top: 10px">
              <div style="font-size: 20px">数据整合和管理困难</div>
              传统测量方式产生的数据往往以纸质或电子表格的形式存在，数据整合和管理起来相对困难。这不仅影响了数据的共享和利用效率，还增加了数据丢失或损坏的风险。
            </div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_2">
        <div>
          <div class="contactus_font">技术特点</div>
          <div style="display: flex; justify-content: center; margin-top: 40px">
            <div class="box_scsl">
              <div class="scsl_font">记录保存优化</div>
              <div class="box_border"></div>
              <div class="scsl_font2">
                由多人人工记录，纸张保存的方式转化为一人机器记录，移动终端计算处理后台保存。减少人工成本加快数据采集速度，减少纸张浪费、节约成本资源
              </div>
            </div>
            <div class="box_scsl">
              <div class="scsl_font">数据展示时效性优化</div>
              <div class="box_border"></div>
              <div class="scsl_font2">
                采集数据工艺完成，实时上传云平台，可供相关人员查看。大大提升了数据时效性，也保证了数据的真实性和可追溯性。
              </div>
            </div>
            <div class="box_scsl">
              <div class="scsl_font">数据共享体系规范优化</div>
              <div class="box_border"></div>
              <div class="scsl_font2">
                确立了从数据采集到数据保存再到
                数据展示数据、共享完整的数据体系，无纸化工作方案，用机器代替人工，减少工作量，提升施工效
                率 。
              </div>
            </div>
            <div class="box_scsl">
              <div class="scsl_font">项目管控过程优化</div>
              <div class="box_border"></div>
              <div class="scsl_font2">
                及时掌握施工进度，及时查阅数据信息，更好的发现问题，更好的安排工作，强化施工管控。
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 60px">
            <img
              style="width: 992px"
              src="../../../static/img/solutions/actualmeasurement/screenshot.png"
              alt=""
            />
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_3">
        <div class="box_tital">产品展示</div>
        <div style="display: flex; justify-content: center">
          <div class="box">
            <div
              v-for="(item, index) in photoArr1"
              :key="index"
              class="box_content"
            >
              <div>
                <img style="height: 300px" :src="item.photoUrl" alt="" />
              </div>
              <div style="margin-top: 15px">
                <div class="box_name">{{ item.ref }}</div>
                <div
                  style="
                    width: 94px;
                    height: 0px;
                    border: 2px solid #1f58ff;
                    margin: 0 auto;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      isSHOW: 1,
      imgActiveIndex: 0, // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0, // 总移动距离
      photoArr1: [
        /*回弹仪*/
        {
          photoUrl: "../../../static/img/photo/photo_huitan.png",
          ref: "智能回弹仪",
        },
        /*智能靠尺*/
        {
          photoUrl: "../../../static/img/photo/photo_rule.png",
          ref: "数字蓝牙智能靠尺",
        },
        /*测距仪*/
        {
          photoUrl: "../../../static/img/photo/photo_ceju03.jpg",
          ref: "智能测距仪",
        },
        /*游标卡尺*/
        {
          photoUrl: "../../../static/img/photo/VernierCaliper01.png",
          ref: "游标卡尺",
        },
        /*智能卷尺*/
        {
          photoUrl: "../../../static/img/photo/tape.png",
          ref: "智能卷尺",
        },
        /*阴阳角尺*/
        {
          photoUrl: "../../../static/img/photo/square.png",
          ref: "阴阳角尺",
        },
        /*钢筋扫描仪*/
        {
          photoUrl: "../../../static/img/photo/scanister.png",
          ref: "钢筋扫描仪",
        },
        /*楼板测厚仪*/
        {
          photoUrl: "../../../static/img/photo/floor.png",
          ref: "楼板测厚仪",
        },
        /*塞尺*/
        {
          photoUrl: "../../../static/img/photo/feelergauge.png",
          ref: "智能塞尺",
        },
        /*混凝土碳化深度检测仪*/
        {
          photoUrl: "../../../static/img/photo/carbide.png",
          ref: "混凝土碳化深度检测仪",
        },
        /*水平仪感光测距仪*/
        {
          photoUrl: "../../../static/img/photo/level.png",
          ref: "水平仪感光测距仪",
        },
        /*实测实量机器人*/
        {
          photoUrl: "../../../static/img/photo/Therobot.jpg",
          ref: "实测实量机器人",
        },
        /*磁粉探伤仪*/
        {
          photoUrl: "../../../static/img/photo/Flawdetector.png",
          ref: "磁粉探伤仪",
        },
        // 顶板极差
        {
          photoUrl: "../../../static/img/photo/Roofplate.png",
          ref: "顶板极差",
        },
      ],
    };
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)`, // 计算移动的距离(x,y,z)
      };
    },
  },
  mounted() {},
  methods: {
    switching(item) {
      this.isSHOW = item;
    },
  },
};
</script>

<style scoped>
.ContactUs_1 {
  height: 700px;
  background-color: #f7f8fa;
  display: flex;
}

.box_font {
  width: 206px;
  height: 46px;
  font-family: SourceHanSansCNRegular;
  /* font-weight: 700; */
  font-size: 26px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  float: right;
  display: flex;
  margin-right: 70px;
}

.box_1 {
  width: 45%;
  margin-top: -5px;
  background-color: #1b2e64;
}

.box1 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box2 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box3 {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  float: right;
  line-height: 230px;
  cursor: pointer;
}

.box_2 {
  width: 55%;
  background-image: url("../../../static/img/solutions/actualmeasurement/Earth.png");
  background-size: 100% 100%;
  margin-top: -5px;
}

.ContactUs_2 {
  height: 750px;
  background-image: url("../../../static/img/solutions/actualmeasurement/three.png");
  background-size: 100% 100%;
}

.box_scsl {
  width: 304px;
  height: 184px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px 12px 12px 12px;
  margin-left: 20px;
}

.box_border {
  width: 198px;
  height: 2px;
  background: #114fff;
  border-radius: 0px 0px 0px 0px;
  margin: 5px 0 0 10px;
}

.scsl_font2 {
  width: 280px;
  height: 115px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  font-size: 16px;
  color: #646464;
  line-height: 23px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin: 5px 0 0 10px;
}

.scsl_font {
  width: 260px;
  height: 35px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  font-size: 24px;
  color: #1a1a1a;
  line-height: 35px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin: 5px 0 0 10px;
}

.ContactUs_4 {
  height: 960px;
  background-image: url("../../../static/img/solutions/actualmeasurement/four.png");
  background-size: 100% 100%;
}

.LunContent {
  background: #ffffff;
}

.LunContent img {
  width: 100%;
  height: 900px;
}

.active {
  border-bottom: 3px solid #6d91f7;
}

.contactus_font {
  margin-top: 3%;
  font-weight: 500;
  font-size: 42px;
  color: #343e51;
  font-family: SourceHanSansCN;
  text-align: center;
}

.TowardsLeft {
  font-size: 30px;
  display: inline-block;
  position: relative;
  top: 50px;
  cursor: pointer;
}

.TowardsRight {
  font-size: 30px;
  display: inline-block;
  position: relative;
  left: 370px;
  top: -55px;
  cursor: pointer;
}

.Img_ul {
  position: relative;
  display: flex;
  left: 36px;
  width: 330px;
  height: 60px;
  overflow: hidden;
  list-style: none;
}
.Img_li {
  float: left;
  margin: 0 7px;
  cursor: pointer;
}

.img_activeBorder {
  border: 2px solid #1966ff !important;
}

.box_3 {
  width: 753px;
  height: 424px;
  background: rgba(13, 28, 71, 0.8);
  border-radius: 4px 4px 4px 4px;
  margin: 100px 0 0 43px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  color: #ffffff;
  padding: 10px;
}

.ContactUs_3 {
  height: 1789px;
  background-image: url("../../../static/img/solutions/smartsite/one.png");
  background-size: 100% 100%;
}

.ContactUs_3 .box {
  width: 1442px;
  height: 1640px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.ContactUs_3 .box_tital {
  height: 61px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  font-size: 42px;
  text-align: center;
  padding: 20px 0 80px 0;
}

.ContactUs_3 .box_content {
  /* width: 386px; */
  height: 380px;
  background: #ffffff;
  margin: 10px;
}

.ContactUs_3 .box_name {
  height: 32px;
  font-family: OPPOSans;
  font-weight: 500;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/solutions/actualmeasurement.vue